/* eslint-disable camelcase */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { addWellnessJourney } from '../../redux/actions';
import { withTranslation } from 'react-i18next';
import Form from '../Form'; // Ensure this path matches your file structure
import Waiting from '../Waiting';
import { Layout } from '../EditWellnessJourney/styles'; // Reusing existing layout styles or from CreateEvent/style

// Initial state for the form
const stateForAdd = {
  title: '',
  description: '', // Short description from Step 1
  articleContent: '', // CKEditor content from Step 3
  image: '',
  imageName: '',
  journey_category_id: [], // Initialize as empty array for multi-select
  selectedOption: 0,
  themeName: '',
  themeMonth: '',
  theme_id: null,
  level: null,
  question: null,
  wellness_goal: null,
  audio: '',
  audioName: '',
  contentType: 'text'
};

class AddWellnessJourney extends Component {
  constructor() {
    super();
    this.state = {
      showLoader: false,
    };
  }

  onSubmit = (e, data) => {
    e.preventDefault();
    const { addWellnessJourney, history, isAdminRoute } = this.props;

    // Build payload based on form data - MATCHING API EXPECTATIONS
    let payload = {
      title: data.title,
      description: data.description, // Short Description
      
      // Journey Category should be a single ID or array depending on API
      journey_category_id: data.journey_category_ids && data.journey_category_ids.length > 0 
        ? data.journey_category_ids.join(',') // or keep as array if API accepts array
        : '',
      
      // Level should be string level name
      levels: data.level && data.level.level ? data.level.level : null,
      
      // Theme related
      themeMonth: data.themeMonth ? data.themeMonth : null,
      themeName: data.themeName ? data.themeName : null,
      theme_id: data.themeId ? data.themeId : null,
      
      // Wellness Goal and Question
      wellness_goal_id: data.wellness_goal && data.wellness_goal.id ? data.wellness_goal.id : null,
      question_id: data.question && data.question.id ? data.question.id : null,
      
      // Content
      content: data.articleContent, // CKEditor content
      content_type: data.contentType, // 'text' or 'audio'
      audio: data.audio,
      audio_name: data.audioName,
      
      // Image
      image: data.image,
      imageName: data.imageName,
      imageUpdated: data.imageUpdated,
      
      // Other
      selectedOption: data.selectedOption ? data.selectedOption : null,
    };

    // Clean up payload - remove null/undefined values
    Object.keys(payload).forEach((key) => {
      if (payload[key] === null || payload[key] === undefined || payload[key] === '') {
        delete payload[key];
      }
    });

    window.console.log('Submitting payload:', payload); // For debugging
    
    this.setState({ showLoader: true });
    addWellnessJourney(payload, history, isAdminRoute);
  };

  render() {
    const { adventureCategories, themes, t, themesHeaderAll, isAdminRoute, history } = this.props;

    if (this.state.showLoader && isAdminRoute) {
      return <Waiting />;
    }

    // Config for mandatory fields per step for validation in Form.js
    const validationConfig = {
      step1: ["title", "image", "description"],
      step2: ["journey_category_id"],
      step3: ["articleContent"]
    };

    return (
      <Layout>
        <Form
          t={t}
          history={history}
          state={stateForAdd}
          validationConfig={validationConfig}
          onSubmit={this.onSubmit}
          journey_category_id={adventureCategories}
          themes={themes}
          themesHeaderAll={themesHeaderAll}
          buttonText={t("Create Journey")}
        />
      </Layout>
    );
  }
}

AddWellnessJourney.propTypes = {
  history: PropTypes.object.isRequired,
  adventureCategories: PropTypes.array.isRequired,
  addWellnessJourney: PropTypes.func.isRequired,
  themes: PropTypes.array.isRequired,
  t: PropTypes.func,
  themesHeaderAll: PropTypes.array,
  isAdminRoute: PropTypes.bool
};

const mapStateToProps = (state) => ({
  isLoading: state.education.isLoading
});

const mapDispatchToProps = (dispatch) => ({
  addWellnessJourney: (data, history, isAdminRoute) => dispatch(addWellnessJourney(data, history, isAdminRoute))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddWellnessJourney)));